import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBackdropClick && _ctx.handleBackdropClick(...args))),
          class: "backdrop"
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("dialog", {
              key: 0,
              open: "",
              id: _ctx.dialogId
            }, [
              _createElementVNode("header", null, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1)
                ], true)
              ]),
              _createElementVNode("section", null, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              (!_ctx.fixed)
                ? (_openBlock(), _createElementBlock("menu", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "actions", {}, () => [
                      _createVNode(_component_base_button, { onClick: _ctx.tryClose }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("Close", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ], true)
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}